import Axios from 'axios';
import dayjs from 'dayjs';
import { GMO_ERROR_MSG } from '../const/gmo/errorcodes';
import { StripeErrorCode } from '../const/stripe/errorcodes';
import { getUnivaPayMessage } from '../const/UnivaPayErrors';
import UnivaClient from './UnivaClient';
Axios.interceptors.request.use(config => {
    const tokenMeta = document.head.querySelector('meta[name="csrfToken"]');
    if (tokenMeta) {
        config.headers["Csrf-Token"] = tokenMeta.getAttribute('content');
    }
    return config;
});
export function getSession() {
    return Axios.get('/api/session');
}
export function deleteCartInProduct(productId) {
    return Axios.get(`/delete/${productId}`);
}
export function updateCartInProductQuantity(id, quantity) {
    return Axios.post('/ajax/cart/quantity/update', {
        id: id,
        quantity: quantity
    });
}
export function getUserSession() {
    return Axios.get('/api/session/user');
}
export function getShotPaySession() {
    return Axios.get('/api/session/shotpayment');
}
export function deleteShotPayProduct(productCode) {
    return Axios.get(`/shotpayment/delete/${productCode}`);
}
export function getLiveInfo(storeId, systemUserId, liveId) {
    return Axios.get('/api/tip/live', {
        params: {
            storeId: storeId,
            systemUserId: systemUserId,
            liveId: liveId
        }
    });
}
export function livePayment(liveForm, paymentForm) {
    return Axios.post('/api/tip/settlement', {
        liveForm: liveForm,
        paymentForm: paymentForm
    });
}
export function getCurrentSchedule() {
    return Axios.get('/api/schedules/current');
}
export function getCurrentPreserves(planId) {
    return Axios.get('/api/schedules/preservedplan', {
        params: {
            planId: planId
        }
    });
}
export async function getHolidays(planGroupId, from, to) {
    return Axios.get('/api/holidays/plan-groups', {
        params: {
            planGroupId,
            from,
            to
        }
    });
}
export function setCurrentPlan(params) {
    return Axios.post('/api/schedules/plans', params);
}
export function setOrderer(params) {
    Object.assign(params, { id: null });
    Object.assign(params, { companyName: null });
    Object.assign(params, { birthday: null });
    Object.assign(params, { gender: null });
    Object.assign(params, { updatedAt: null });
    Object.assign(params, { createdAt: null });
    return Axios.post('/api/schedules/plans/orderer', params);
}
export function setSchedulePaymentForm(params) {
    return Axios.post('/api/schedules/plans/payment', params);
}
export function preserveSchedulePayPlan() {
    return Axios.post('/api/schedules/plans/preserve');
}
export function payOnTheDaySchedule(code, form) {
    return Axios.post(`/api/schedules/payontheday/${code}`, form);
}
export function formSubmit(params, url, selector, prefix) {
    let form = document.createElement('form');
    form.action = url;
    form.method = "POST";
    // セレクタの指定、かつ、フォームが存在する場合のみ既存のFormを使う
    if (selector != null) {
        let reserveForm = document.querySelector(selector);
        if (reserveForm) {
            form = reserveForm;
        }
    }
    const tokenMeta = document.head.querySelector('meta[name="csrfToken"]');
    if (tokenMeta) {
        const csrf = document.createElement('input');
        csrf.name = "csrfToken";
        csrf.type = "hidden";
        csrf.value = tokenMeta.getAttribute('content') ?? '';
        form.appendChild(csrf);
    }
    Object.entries(params).forEach(param => {
        const fieldName = param[0];
        const fieldValue = param[1];
        if (fieldValue instanceof Array) {
            fieldValue.forEach((val, index) => {
                const field = document.createElement('input');
                field.type = "hidden";
                field.name = prefix ? `${prefix}.${fieldName}[${index}]` : `${fieldName}[${index}]`;
                field.value = val;
                form.appendChild(field);
            });
        }
        else {
            const field = document.createElement('input');
            field.type = "hidden";
            field.name = prefix ? `${prefix}.${fieldName}` : fieldName;
            field.value = fieldValue;
            form.appendChild(field);
        }
    });
    if (!selector) {
        document.body.appendChild(form);
    }
    form.submit();
}
export var Tokens;
(function (Tokens) {
    function getStoreType(storeId, cardBrandType) {
        return Axios.get("/api/firstpaytoken/store", {
            params: {
                storeId: storeId,
                cardBrandType: cardBrandType
            }
        });
    }
    Tokens.getStoreType = getStoreType;
    function getStoreInfo(storeId) {
        return Axios.post(`/api/store/${storeId}`);
    }
    Tokens.getStoreInfo = getStoreInfo;
    async function getGMOCardToken(card, storeIdentifier, callback) {
        // @ts-ignore
        Multipayment.init(storeIdentifier);
        // @ts-ignore
        Multipayment.getToken({
            cardno: card.cardno,
            expire: `${card.expireyear}${card.expiremonth}`,
            securitycode: card.cvc,
            holdername: card.holdername,
            tokennumber: 2
        }, function (result) {
            if (result.resultCode === "000") {
                callback(result.tokenObject.token);
            }
            else {
                const errorMsg = Object.entries(GMO_ERROR_MSG).filter(p => p[0] === result.resultCode);
                if (errorMsg.length > 0) {
                    throw new Error(errorMsg[0][1]);
                }
                throw new Error("トークンの取得に失敗しました");
            }
        });
    }
    function getAquagatesCardToken(card, storeId) {
        const memberCode = generateMemberCode();
        return Axios.post('/api/card/tokenize', {
            storeId: storeId,
            storeType: 'AQUAGATES',
            cardno: card.cardno,
            cardname: card.holdername,
            expire: dayjs(`${card.expireyear}-${card.expiremonth}-01`).format('MM/YY'),
            cvv: card.cvc,
            memberCode: memberCode,
        }).then(response => {
            return [memberCode, null, response.data.token];
        }).catch(_ => {
            throw new Error("トークンの取得に失敗しました");
        });
    }
    function getNFTSCardToken(card, storeId) {
        const memberCode = "swapay_" + generateMemberCode().slice(0, -7);
        return Axios.post('/api/card/tokenize', {
            storeId: storeId,
            storeType: 'NFTS',
            cardno: card.cardno,
            cardname: card.holdername,
            expire: dayjs(`${card.expireyear}-${card.expiremonth}-01`).format('MM/YY'),
            cvv: card.cvc,
            memberCode: memberCode,
        }).then(response => {
            return [memberCode, null, response.data.token];
        }).catch(_ => {
            throw new Error("トークンの取得に失敗しました");
        });
    }
    function getStripeCardToken(card, storeSecret) {
        const formData = new URLSearchParams();
        formData.set('card[number]', card.cardno);
        formData.set('card[exp_month]', card.expiremonth);
        formData.set('card[exp_year]', card.expireyear);
        formData.set('card[cvc]', card.cvc);
        formData.set('card[name]', card.holdername);
        formData.set('card[address_country]', 'JP');
        return Axios.post('https://api.stripe.com/v1/tokens', formData, {
            headers: {
                "Authorization": `Bearer ${storeSecret}`
            }
        }).then(response => {
            return [response.data.id, response.data.card?.id];
        }).catch(e => {
            const code = e.response.data.error.code ?? '';
            const declineCode = e.response.data.error.decline_code ?? '';
            const message = StripeErrorCode.errorCodeToMsg(code, declineCode);
            throw new Error(message);
        });
    }
    async function getUnivaPayTransactionToken(card, storeId) {
        try {
            const result = await UnivaClient.getToken(card, storeId);
            console.log(result);
            return [result.data.id];
        }
        catch (e) {
            // TODO: エラーハンドリング
            if ((Axios.isAxiosError(e)) === true) {
                const { response } = e;
                if (response) {
                    const { errors } = response.data;
                    const messages = getUnivaPayMessage(errors.map(m => m.reason));
                    throw new Error(messages.join('\n'));
                }
            }
            throw e;
        }
    }
    function generateMemberCode() {
        const str = "1234567890";
        const len = 60;
        let result = "";
        for (var i = 0; i < len; i++) {
            result += str.charAt(Math.floor(Math.random() * str.length));
        }
        return result;
    }
    Tokens.generateMemberCode = generateMemberCode;
    async function getToken(card, storeType, storeId, storeIdentifier, storeSecret) {
        let token = [];
        switch (storeType) {
            case "GMO":
                await getGMOCardToken(card, storeIdentifier, await function (createdTokens) {
                    token = createdTokens;
                    let evt = new CustomEvent("--get-token", { detail: { tokens: token } });
                    document.dispatchEvent(evt);
                });
                break;
            case "STRIPE":
                token = await getStripeCardToken(card, storeSecret);
                let stripeEvt = new CustomEvent("--get-token", { detail: { tokens: token } });
                document.dispatchEvent(stripeEvt);
                break;
            case "UPC":
                const transactionToken = await getUnivaPayTransactionToken(card, storeId);
                let upcEvt = new CustomEvent("--get-token", { detail: { tokens: transactionToken } });
                document.dispatchEvent(upcEvt);
                break;
            case "NFTS":
                // 後続で操作するのでここでは何もしない
                token = await getNFTSCardToken(card, storeId);
                let nftsEvt = new CustomEvent("--get-token", { detail: { tokens: token } });
                document.dispatchEvent(nftsEvt);
                break;
            default:
                token = await getAquagatesCardToken(card, storeId);
                let evt = new CustomEvent("--get-token", { detail: { tokens: token } });
                document.dispatchEvent(evt);
                break;
        }
    }
    Tokens.getToken = getToken;
    function registerCard(storeId, tokens, cardBrandType, cardSequence) {
        return Axios.post('/cart/card/register', {
            storeId: storeId,
            tokens: tokens,
            cardSequence: cardSequence,
            cardBrandType: cardBrandType
        });
    }
    Tokens.registerCard = registerCard;
    function deleteCard(storeId, id) {
        return Axios.post('/cart/card/delete', {
            storeId: storeId,
            id: id
        });
    }
    Tokens.deleteCard = deleteCard;
})(Tokens || (Tokens = {}));
export var Stores;
(function (Stores) {
    async function availableVendors(storeId) {
        return Axios.post(`/api/store/vendors/${storeId}`);
    }
    Stores.availableVendors = availableVendors;
})(Stores || (Stores = {}));
export var Members;
(function (Members) {
    async function getSwapayMember(storeId, tel, email) {
        return Axios.post('/api/members/swapay', {
            storeId,
            tel,
            email
        });
    }
    Members.getSwapayMember = getSwapayMember;
    async function saveSwapayMember(storeId, memberCode, tel, email) {
        return Axios.post('/api/members/swapay/save', {
            storeId,
            memberCode,
            tel,
            email
        });
    }
    Members.saveSwapayMember = saveSwapayMember;
    async function retrieveSwapayUser(storeId, id) {
        return Axios.post('/api/members/swapay/single', {
            storeId, id
        });
    }
    Members.retrieveSwapayUser = retrieveSwapayUser;
    async function resendVerification(storeId, id) {
        return Axios.post(`/api/members/swapay/resend/${storeId}/${id}`, {});
    }
    Members.resendVerification = resendVerification;
})(Members || (Members = {}));
export var ThreeDS;
(function (ThreeDS) {
    async function getStatus(orderCode) {
        return Axios.get(`/api/payment/3ds/${orderCode}`);
    }
    ThreeDS.getStatus = getStatus;
})(ThreeDS || (ThreeDS = {}));
